<template>
    <layout-default>
        <div class="purchase-container">
            <!-- Conditional rendering for purchase components -->
            <PurchaseConfirmation v-if="purchaseStatus === 'success'" />
            <PurchaseRejected v-else-if="purchaseStatus === 'rejected'" />
            
            <!-- Default content when no purchase status is set -->
            <div v-else class="default-purchase-content">
                <h1>Purchase Page</h1>
                <p>Select a purchase status to view the appropriate component:</p>
                <div class="status-buttons">
                    <button @click="setPurchaseStatus('success')" class="btn-success">
                        Show Success Purchase
                    </button>
                    <button @click="setPurchaseStatus('rejected')" class="btn-rejected">
                        Show Rejected Purchase
                    </button>
                </div>
            </div>
        </div>
    </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import PurchaseConfirmation from "@/components/purchase/PurchaseConfirmation";
import PurchaseRejected from "@/components/purchase/PurchaseRejected";

export default {
    name: 'NewVersionPurchase',
    components: {
        LayoutDefault,
        PurchaseConfirmation,
        PurchaseRejected
    },
    data() {
        return {
            purchaseStatus: 'success' // Set to 'success' to show PurchaseConfirmation by default
        }
    },
    methods: {
        setPurchaseStatus(status) {
            this.purchaseStatus = status;
        }
    }
}
</script>

<style scoped>
.purchase-container {
    padding: 20px;
}

.default-purchase-content {
    text-align: center;
    padding: 40px;
}

.status-buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-top: 20px;
}

.btn-success {
    background-color: #10b981;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.btn-rejected {
    background-color: #ef4444;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.btn-success:hover {
    background-color: #059669;
}

.btn-rejected:hover {
    background-color: #dc2626;
}
</style>
